document.addEventListener('DOMContentLoaded', function () {
    timelineBlock()
})

function timelineBlock() {
    const timelines = document.querySelectorAll('.timeline-block')
    if (timelines) {
        // Timeline filtering
        const filterBtns = document.querySelectorAll('.timeline__filter button')

        filterBtns.forEach((el) => {
            el.addEventListener('click', (e) => {
                const targetTimeline = e.currentTarget.closest('.timeline-block').querySelector('.the-timeline')
                const allItems = targetTimeline.querySelectorAll('.timeline__item')
                const selectedFilter = e.currentTarget.getAttribute('data-filter')
                const otherBtns = e.currentTarget.closest('.timeline__filter').querySelectorAll('button')

                otherBtns.forEach((btns) => {
                    btns.classList.remove('is-selected')
                })

                e.currentTarget.classList.add('is-selected')

                allItems.forEach((item) => {
                    if (selectedFilter === 'all') {
                        item.classList.remove('hidden-item')
                    } else {
                        if (item.getAttribute('data-category') !== selectedFilter) {
                            item.classList.add('hidden-item')
                        } else {
                            item.classList.remove('hidden-item')
                        }
                    }
                })

                const year = document.querySelectorAll('.timeline__year')
                year.forEach((el) => {
                    const items = el.querySelectorAll('.timeline__item')
                    let hidden = 0
                    items.forEach((item) => {
                        if (item.classList.contains('hidden-item')) {
                            hidden++
                        }
                    })
                    if (hidden === items.length) {
                        el.classList.add('hidden-item')
                    } else {
                        el.classList.remove('hidden-item')
                    }
                })
            })
        })

        // Toggle filtering
        const filterToggle = document.querySelectorAll('.filter-toggle')

        filterToggle.forEach((el) => {
            el.addEventListener('click', (e) => {
                const filterDropdown = e.currentTarget.parentNode.querySelector('.timeline__filter')

                filterDropdown.classList.toggle('show')
                filterDropdown.addEventListener('click', (e) => {
                    e.currentTarget.classList.remove('show')
                })
            })
        })

        // Hide inactive categories from filter
        timelines.forEach((timeline) => {
            const items = timeline.querySelectorAll('.timeline__item')
            const listItems = timeline.querySelectorAll('.timeline__filter li')
            const relCats = []

            items.forEach((el) => {
                let attr = el.getAttribute('data-category')
                relCats.push(attr)
            })

            listItems.forEach((el) => {
                let categoryBtn = el.querySelector('button')
                let category = categoryBtn.getAttribute('data-filter')

                if (!relCats.includes(category) && category != 'all') {
                    el.classList.add('inactive-category')
                }
            })
        })
    }
}
